<template>
  <div>rate</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
